import React from "react";
import { useTranslation } from "react-i18next";

import CustomInput from "../../shared/custom-components/customInput";
import StepButtons from "./stepButtons";
import RadioButton from "canvas-core-react/lib/RadioButton";
import useForm from "../../hooks/useForm";

const AccountForm = ({
  initialState = [],
  nextStep,
  previousStep,
  reviewMode,
}) => {
  const { t } = useTranslation();

  const { setValue, values, onSubmit } = useForm({
    initialState: initialState.reduce((acc, { globalApproval, id }) => {
      acc[id] = globalApproval;
      return acc;
    }, {}),
    callback: (data) =>
      nextStep(
        initialState.map((item) => ({ ...item, globalApproval: data[item.id] }))
      ),
  });

  return (
    <div className="w-100">
      <h3 className="form-title">{t(`${baseName}title`)}</h3>
      {initialState.map((account, index) => (
        <div className="mb-4" key={account.currency}>
          <h3 className="mb-3">
            {t("account")} #{index + 1}{" "}
            {`(${t(`general.currency.${account.currency}`)})`}
          </h3>
          <div className="d-flex justify-content-between flex-wrap">
            {options.map((name) => (
              <div className="width-column" key={name}>
                <CustomInput
                  name={name}
                  label={t(`providers.detail.${name}`)}
                  value={account[name]}
                  id={name}
                  disabled={true}
                  className="input-new-provider-fix"
                />
              </div>
            ))}
          </div>
          <div className="mb-5">
            <label className="label-admin-client mt-3">
              {t(`${baseName}globalApprovalTitle`)}
            </label>
            <div className="flex-element radio-group">
              <RadioButton
                label={t("general.labels.yes")}
                disabled={reviewMode}
                checked={values[account.id]}
                onChange={() => setValue(account.id, true)}
                id={`${account.id}-yes`}
                name={`${account.id}-yes`}
              />
              <RadioButton
                label={t("general.labels.no")}
                disabled={reviewMode}
                checked={!values[account.id]}
                onChange={() => setValue(account.id, false)}
                id={`${account.id}-no`}
                name={`${account.id}-no`}
              />
            </div>
          </div>
        </div>
      ))}

      {!reviewMode && (
        <StepButtons nextStep={onSubmit} previousStep={previousStep} />
      )}
    </div>
  );
};

export default AccountForm;

const baseName = "registerProvider.forms.account.";

const options = [
  "accountType",
  "currency",
  "accountNumber",
  "bicDestinationBank",
  "bicIntermediaryBank",
  "bicAccountIntermediaryBank",
];
